import React from 'react';
import './styles/Ticket.css';

const Ticket = ({ reserveTicketsNum, data, ticketButtonPressed }) => {

    const amountLeft = () => {
        if (data.numAvailable && reserveTicketsNum) {
            return data.numAvailable - reserveTicketsNum
        }
    };

    return (
        <div className="ticket-border">
            <div className="notch left"></div>
            <div className="notch right"></div>
            <div className="ticket">
                <div className="ticket-top">
                    <h3>{data.type}</h3>
                    <h3>{"R " + data.price}</h3>
                </div>
                <div className="ticket-body">
                    <p>{data.desc}</p>
                </div>
                <div className="ticket-footer">
                    <div className='footer-left'>
                        {amountLeft() !== undefined && amountLeft() <= 100 &&
                            <p>{amountLeft() <= 0 ? "Sold Out" : "Only " + amountLeft() + " left"}</p>
                        }
                    </div>
                    <div className='footer-right'>
                        <button onClick={() => ticketButtonPressed(data.type, "-")} className='ticket-button'>
                            <p>-</p>
                        </button>
                        <input className='ticket-amount' type='number' value={data.amount} readOnly></input>
                        <button onClick={() => ticketButtonPressed(data.type, "+")} className='ticket-button'>
                            <p>+</p>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Ticket;
